import { fromJS } from "immutable";
import { CreateProcess } from "redux-process";

export const SelectionObjectCountUsers = CreateProcess({
	method: "GET",
	name: "SelectionObjectCountUsers",
	type: "SELECTIONOBJECT:COUNT",

	request: (props) => ({
		url: `/api/user_selection/${props.id}/count/`,
	}),

	success: (response) => fromJS({ count: response.data.count }),
});

export const SelectionObjectCreate = CreateProcess({
	method: "POST",
	name: "SelectionObjectCreate",
	type: "SELECTIONOBJECT:CREATE",

	request: () => ({
		url: "/api/user_selection/",
	}),

	success: (response) => fromJS({ selectionObjectID: response.data.user_selection_id }),
});
